import React from 'react';
import PropTypes from 'prop-types';

import { isNonEmptyString, createCustomPropType } from '../../../js/app/react/validators';

import AdvWorkflow from '../AdvWorkflow/AdvWorkflowContainer';
import PartnerName from './Steps/PartnerNameContainer';
import Age from './Steps/AgeContainer';
import AreYouMarried from './Steps/AreYouMarriedContainer';
import DoYouHaveChildren from './Steps/DoYouHaveChildrenContainer';
import ChildrenOverview from './Steps/ChildrenOverviewContainer';

const PersonalInfoWorkflowView = ({ branch, workflowId }) => (
  <AdvWorkflow
    branch={branch}
    workflowId={workflowId}
    steps={[AreYouMarried, PartnerName, Age, DoYouHaveChildren, ChildrenOverview]}
  />
);

PersonalInfoWorkflowView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  partner: PropTypes.shape({}).isRequired,
};

export default PersonalInfoWorkflowView;
